const PRODUCT_CONSTANT = '/p/'
/**
 * Given a product and the current locale returns an href to the product detail page.
 *
 * @param {Object} product
 * @returns {string}
 */
export const productUrlBuilder = (product) => {
    if (product?.c_variationGroup_slugUrl) return encodeURI(product?.c_variationGroup_slugUrl)
    if (product?.c_slugUrl) return encodeURI(product?.c_slugUrl)
    return productUrlBuilderFromSlug(product) // TODO: Remove wheh this the custom slug field will be present in all the apis
}

export const productUrlBuilderFromSlug = (product) => {
    const slug = product?.slugUrl?.split(PRODUCT_CONSTANT)?.[1]
    if (slug) {
        const url = PRODUCT_CONSTANT + slug
        return encodeURI(url)
    }
    return PRODUCT_CONSTANT + product?.productId + '.html'
}

export * from '@salesforce/retail-react-app/app/utils/url'
